import { Injectable } from '@angular/core';
import { deepCopy } from 'na-lib';

@Injectable({
  providedIn: 'root'
})
export class WidgetClipboardService {
  private widget: any | null = null;
  private sourcePassId: string | null = null;
  private translationsSlice: any | null = null;

  setWidget(widget: any, sourcePassId?: string, translationsSlice?: any): void {
    this.widget = deepCopy(widget);
    this.sourcePassId = sourcePassId || null;
    this.translationsSlice = translationsSlice ? deepCopy(translationsSlice) : null;
  }

  getWidget(): any | null {
    return this.widget ? deepCopy(this.widget) : null;
  }

  getSourcePassId(): string | null {
    return this.sourcePassId;
  }

  getTranslationsSlice(): any | null {
    return this.translationsSlice ? deepCopy(this.translationsSlice) : null;
  }

  hasWidget(): boolean {
    return !!this.widget;
  }

  clear(): void {
    this.widget = null;
    this.sourcePassId = null;
    this.translationsSlice = null;
  }
}
